import { useMemo, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Spinner } from "../shared/Spinner";
import {
  FilterSection,
  HeaderSection,
  TradingParametersGrid,
  TradingParametersWrapper,
} from "./style";
import { TradingParameterCard } from "./components/TradingParameterCard";
import { useTradingParameters } from "../../hooks/api/admin/useTradingParameters";
import { ReactComponent as Edit } from "../../assets/svg/edit.svg";
import { MarketDropdown } from "../Dropdown/MarketDropdown";
import { FilterWrapper } from "../Table/style";
import { SpinnerContainerWrapper } from "../shared/Spinner/style";

export function TradingParameters() {
  const { data: parametersData, updateTradingParameters } = useTradingParameters();
  const [selectedAsset, setAsset] = useState<string | undefined>(undefined);

  const filteredParameters = useMemo(() => {
    if (parametersData) {
      if (selectedAsset) {
        return parametersData.filter((param) => param.asset === selectedAsset);
      }
      return parametersData;
    }
    return [];
  }, [selectedAsset, parametersData]);

  // Show loading spinner only on initial load (when there's no data yet)
  // Keep showing existing data during refetches for better UX
  const isInitialLoading = !parametersData;

  return (
    <TradingParametersWrapper>
      <HeaderSection>
        <Edit /> Trading Parameters
      </HeaderSection>

      <FilterSection>
        <div>
          <FilterWrapper>Assets</FilterWrapper>
          <MarketDropdown onClick={setAsset} />
        </div>
      </FilterSection>

      <AnimatePresence>
        {isInitialLoading ? (
          <SpinnerContainerWrapper height="50vh">
            <Spinner />
          </SpinnerContainerWrapper>
        ) : (
          <TradingParametersGrid
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {filteredParameters.map((param) => (
              <TradingParameterCard
                key={param.asset}
                parameters={param}
                onUpdate={updateTradingParameters}
              />
            ))}
          </TradingParametersGrid>
        )}
      </AnimatePresence>
    </TradingParametersWrapper>
  );
}
